export default __webpack_public_path__ + "static/media/mbLogo.eafe96de.png";